// // src/slices/userSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import axios from "axios";
// import { User, UserState } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   loading: false,
//   error: null,
//   profileUpdated: false,
// };

// // Define the base URL for the API
// const API_URL = "/api/users";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >(
//   "user/fetchUserProfile",
//   async (
//     { jwt, navigate }: { jwt: string; navigate: any },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await api.get(`${API_URL}/profile`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });
//       console.log(" user profile ", response.data);
//       if (response.data.role === "ROLE_ADMIN") {
//         navigate("/admin");
//       }
//       return response.data;
//     } catch (error: any) {
//       console.log("error ", error.response);
//       return rejectWithValue("Failed to fetch user profile");
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;


// src/slices/userSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { User, UserState, Address } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   loading: false,
//   error: null,
//   profileUpdated: false,
// };

// const API_URL = "/api/users";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >(
//   "user/fetchUserProfile",
//   async ({ jwt, navigate }, { rejectWithValue }) => {
//     try {
//       const response = await api.get(`${API_URL}/profile`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       console.log("user profile", response.data);

//       if (response.data.role === "ROLE_ADMIN") {
//         navigate("/admin");
//       }

//       return response.data;
//     } catch (error: any) {
//       console.log("error", error.response);
//       return rejectWithValue("Failed to fetch user profile");
//     }
//   }
// );

// export const addUserAddress = createAsyncThunk<
//   User,
//   { jwt: string; address: Address }
// >("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
//   try {
//     const response = await api.post(`${API_URL}/addresses`, address, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("add address error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to add address"
//     );
//   }
// });

// export const updateUserAddress = createAsyncThunk<
//   User,
//   { jwt: string; addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ jwt, addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `${API_URL}/addresses/${addressId}`,
//         address,
//         {
//           headers: { Authorization: `Bearer ${jwt}` },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update address"
//       );
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<
//   number,
//   { jwt: string; addressId: number }
// >(
//   "user/deleteUserAddress",
//   async ({ jwt, addressId }, { rejectWithValue }) => {
//     try {
//       await api.delete(`${API_URL}/addresses/${addressId}`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to delete address"
//       );
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addUserAddress.fulfilled, (state, action: PayloadAction<User>) => {
//         state.user = action.payload;
//         state.loading = false;
//       })
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         updateUserAddress.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         deleteUserAddress.fulfilled,
//         (state, action: PayloadAction<number>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.filter(
//               (address) => address.id !== action.payload
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;


// src/Redux Toolkit/Customer/UserSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { User, UserState, Address } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   loading: false,
//   error: null,
//   profileUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >("user/fetchUserProfile", async ({ jwt, navigate }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(`${API_URL}/profile`, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     if (response.data.role === "ROLE_ADMIN") {
//       navigate("/admin");
//     }

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user profile error", error.response);
//     return rejectWithValue("Failed to fetch user profile");
//   }
// });

// export const addUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; address: Address }
// >("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
//   try {
//     const response = await api.post(ADDRESS_API_URL, address, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("add address error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to add address"
//     );
//   }
// });

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ jwt, addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `${ADDRESS_API_URL}/${addressId}`,
//         address,
//         {
//           headers: { Authorization: `Bearer ${jwt}` },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update address"
//       );
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<
//   number,
//   { jwt: string; addressId: number }
// >(
//   "user/deleteUserAddress",
//   async ({ jwt, addressId }, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to delete address"
//       );
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         addUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user) {
//             state.user.addresses = [
//               ...(state.user.addresses || []),
//               action.payload,
//             ];
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         updateUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.map((address) =>
//               address.id === action.payload.id ? action.payload : address
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         deleteUserAddress.fulfilled,
//         (state, action: PayloadAction<number>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.filter(
//               (address) => address.id !== action.payload
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;



// // src/Redux Toolkit/Customer/UserSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { User, UserState, Address } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   loading: false,
//   error: null,
//   profileUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >("user/fetchUserProfile", async ({ jwt, navigate }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(`${API_URL}/profile`, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     if (response.data.role === "ROLE_ADMIN") {
//       navigate("/admin");
//     }

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user profile error", error.response);
//     return rejectWithValue("Failed to fetch user profile");
//   }
// });

// export const fetchUserAddresses = createAsyncThunk<
//   Address[],
//   { jwt: string }
// >("user/fetchUserAddresses", async ({ jwt }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(ADDRESS_API_URL, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user addresses error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to fetch addresses"
//     );
//   }
// });

// export const addUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; address: Address }
// >("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
//   try {
//     const response = await api.post(ADDRESS_API_URL, address, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("add address error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to add address"
//     );
//   }
// });

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ jwt, addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `${ADDRESS_API_URL}/${addressId}`,
//         address,
//         {
//           headers: { Authorization: `Bearer ${jwt}` },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update address"
//       );
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<
//   number,
//   { jwt: string; addressId: number }
// >(
//   "user/deleteUserAddress",
//   async ({ jwt, addressId }, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to delete address"
//       );
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(fetchUserAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserAddresses.fulfilled,
//         (state, action: PayloadAction<Address[]>) => {
//           if (state.user) {
//             state.user.addresses = action.payload;
//           } else {
//             state.user = {
//               addresses: action.payload,
//             } as User;
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         addUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user) {
//             state.user.addresses = [
//               ...(state.user.addresses || []),
//               action.payload,
//             ];
//           } else {
//             state.user = {
//               addresses: [action.payload],
//             } as User;
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         updateUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.map((address) =>
//               address.id === action.payload.id ? action.payload : address
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         deleteUserAddress.fulfilled,
//         (state, action: PayloadAction<number>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.filter(
//               (address) => address.id !== action.payload
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;




// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { Address, User, UserState } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   addresses: [],
//   loading: false,
//   error: null,
//   profileUpdated: false,
//   addressUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// const getJwt = () => localStorage.getItem("jwt") || "";

// const syncUserAddresses = (state: UserState, addresses: Address[]) => {
//   state.addresses = addresses;

//   if (state.user) {
//     state.user.addresses = addresses;
//   }
// };

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >(
//   "user/fetchUserProfile",
//   async ({ jwt, navigate }, { rejectWithValue }) => {
//     try {
//       const response = await api.get(`${API_URL}/profile`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       if (response.data.role === "ROLE_ADMIN") {
//         navigate("/admin");
//       }

//       return response.data;
//     } catch (error: any) {
//       console.log("error ", error.response);
//       return rejectWithValue("Failed to fetch user profile");
//     }
//   }
// );

// export const fetchUserAddresses = createAsyncThunk<Address[]>(
//   "user/fetchUserAddresses",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(ADDRESS_API_URL, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("fetch addresses error ", error.response);
//       return rejectWithValue("Failed to fetch addresses");
//     }
//   }
// );

// export const addUserAddress = createAsyncThunk<Address, Address>(
//   "user/addUserAddress",
//   async (address, { rejectWithValue }) => {
//     try {
//       const response = await api.post(ADDRESS_API_URL, address, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("add address error ", error.response);
//       return rejectWithValue("Failed to add address");
//     }
//   }
// );

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(`${ADDRESS_API_URL}/${addressId}`, address, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error ", error.response);
//       return rejectWithValue("Failed to update address");
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<number, number>(
//   "user/deleteUserAddress",
//   async (addressId, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error ", error.response);
//       return rejectWithValue("Failed to delete address");
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.addresses = [];
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//       state.addressUpdated = false;
//     },
//     resetAddressUpdated: (state) => {
//       state.addressUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.addresses = action.payload.addresses || [];
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(fetchUserAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserAddresses.fulfilled,
//         (state, action: PayloadAction<Address[]>) => {
//           syncUserAddresses(state, action.payload);
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(addUserAddress.fulfilled, (state, action) => {
//         const newAddress = action.payload;

//         let updatedAddresses = state.addresses;

//         if (newAddress.defaultAddress) {
//           updatedAddresses = updatedAddresses.map((address) => ({
//             ...address,
//             defaultAddress: false,
//           }));
//         }

//         syncUserAddresses(state, [...updatedAddresses, newAddress]);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(updateUserAddress.fulfilled, (state, action) => {
//         const updatedAddress = action.payload;

//         let updatedAddresses = state.addresses;

//         if (updatedAddress.defaultAddress) {
//           updatedAddresses = updatedAddresses.map((address) => ({
//             ...address,
//             defaultAddress: false,
//           }));
//         }

//         updatedAddresses = updatedAddresses.map((address) =>
//           address.id === updatedAddress.id ? updatedAddress : address
//         );

//         syncUserAddresses(state, updatedAddresses);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(deleteUserAddress.fulfilled, (state, action) => {
//         const updatedAddresses = state.addresses.filter(
//           (address) => address.id !== action.payload
//         );

//         syncUserAddresses(state, updatedAddresses);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       });
//   },
// });

// export const { resetUserState, resetAddressUpdated } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserAddresses = (state: RootState) => state.user.addresses;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;




// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { Address, User, UserState } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   addresses: [],
//   loading: false,
//   error: null,
//   profileUpdated: false,
//   addressUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// const getJwt = () => localStorage.getItem("jwt") || "";

// const syncUserAddresses = (state: UserState, addresses: Address[]) => {
//   state.addresses = addresses;

//   if (state.user) {
//     state.user.addresses = addresses;
//   }
// };

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >(
//   "user/fetchUserProfile",
//   async ({ jwt, navigate }, { rejectWithValue }) => {
//     try {
//       const response = await api.get(`${API_URL}/profile`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       if (response.data.role === "ROLE_ADMIN") {
//         navigate("/admin");
//       }

//       return response.data;
//     } catch (error: any) {
//       console.log("error ", error.response);
//       return rejectWithValue("Failed to fetch user profile");
//     }
//   }
// );

// export const fetchUserAddresses = createAsyncThunk<Address[]>(
//   "user/fetchUserAddresses",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(ADDRESS_API_URL, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("fetch addresses error ", error.response);
//       return rejectWithValue("Failed to fetch addresses");
//     }
//   }
// );

// export const addUserAddress = createAsyncThunk<Address, Address>(
//   "user/addUserAddress",
//   async (address, { rejectWithValue }) => {
//     try {
//       const response = await api.post(ADDRESS_API_URL, address, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("add address error ", error.response);
//       return rejectWithValue("Failed to add address");
//     }
//   }
// );

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(`${ADDRESS_API_URL}/${addressId}`, address, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error ", error.response);
//       return rejectWithValue("Failed to update address");
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<number, number>(
//   "user/deleteUserAddress",
//   async (addressId, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${getJwt()}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error ", error.response);
//       return rejectWithValue("Failed to delete address");
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.addresses = [];
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//       state.addressUpdated = false;
//     },
//     resetAddressUpdated: (state) => {
//       state.addressUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.addresses = action.payload.addresses || [];
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(fetchUserAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserAddresses.fulfilled,
//         (state, action: PayloadAction<Address[]>) => {
//           syncUserAddresses(state, action.payload);
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(addUserAddress.fulfilled, (state, action) => {
//         const newAddress = action.payload;

//         let updatedAddresses = state.addresses;

//         if (newAddress.defaultAddress) {
//           updatedAddresses = updatedAddresses.map((address) => ({
//             ...address,
//             defaultAddress: false,
//           }));
//         }

//         syncUserAddresses(state, [...updatedAddresses, newAddress]);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(updateUserAddress.fulfilled, (state, action) => {
//         const updatedAddress = action.payload;

//         let updatedAddresses = state.addresses;

//         if (updatedAddress.defaultAddress) {
//           updatedAddresses = updatedAddresses.map((address) => ({
//             ...address,
//             defaultAddress: false,
//           }));
//         }

//         updatedAddresses = updatedAddresses.map((address) =>
//           address.id === updatedAddress.id ? updatedAddress : address
//         );

//         syncUserAddresses(state, updatedAddresses);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })
//       .addCase(deleteUserAddress.fulfilled, (state, action) => {
//         const updatedAddresses = state.addresses.filter(
//           (address) => address.id !== action.payload
//         );

//         syncUserAddresses(state, updatedAddresses);
//         state.loading = false;
//         state.addressUpdated = true;
//       })
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.addressUpdated = false;
//       });
//   },
// });

// export const { resetUserState, resetAddressUpdated } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserAddresses = (state: RootState) => state.user.addresses;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;




// // src/Redux Toolkit/Customer/UserSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { User, UserState, Address } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   addresses: [],
//   loading: false,
//   error: null,
//   profileUpdated: false,
//   addressUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >("user/fetchUserProfile", async ({ jwt, navigate }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(`${API_URL}/profile`, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     if (response.data.role === "ROLE_ADMIN") {
//       navigate("/admin");
//     }

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user profile error", error.response);
//     return rejectWithValue("Failed to fetch user profile");
//   }
// });

// export const fetchUserAddresses = createAsyncThunk<
//   Address[],
//   { jwt: string }
// >("user/fetchUserAddresses", async ({ jwt }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(ADDRESS_API_URL, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user addresses error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to fetch addresses"
//     );
//   }
// });

// export const addUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; address: Address }
// >("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
//   try {
//     const response = await api.post(ADDRESS_API_URL, address, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("add address error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to add address"
//     );
//   }
// });

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ jwt, addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `${ADDRESS_API_URL}/${addressId}`,
//         address,
//         {
//           headers: { Authorization: `Bearer ${jwt}` },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update address"
//       );
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<
//   number,
//   { jwt: string; addressId: number }
// >(
//   "user/deleteUserAddress",
//   async ({ jwt, addressId }, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to delete address"
//       );
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(fetchUserAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchUserAddresses.fulfilled,
//         (state, action: PayloadAction<Address[]>) => {
//           if (state.user) {
//             state.user.addresses = action.payload;
//           } else {
//             state.user = {
//               addresses: action.payload,
//             } as User;
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(fetchUserAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         addUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user) {
//             state.user.addresses = [
//               ...(state.user.addresses || []),
//               action.payload,
//             ];
//           } else {
//             state.user = {
//               addresses: [action.payload],
//             } as User;
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         updateUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.map((address) =>
//               address.id === action.payload.id ? action.payload : address
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         deleteUserAddress.fulfilled,
//         (state, action: PayloadAction<number>) => {
//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.filter(
//               (address) => address.id !== action.payload
//             );
//           }

//           state.loading = false;
//         }
//       )
//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;




// src/Redux Toolkit/Customer/UserSlice.ts
// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { User, UserState, Address } from "../../types/userTypes";
// import { api } from "../../Config/Api";
// import { RootState } from "../Store";

// const initialState: UserState = {
//   user: null,
//   addresses: [],
//   loading: false,
//   error: null,
//   profileUpdated: false,
//   addressUpdated: false,
// };

// const API_URL = "/api/users";
// const ADDRESS_API_URL = "/api/users/addresses";

// export const fetchUserProfile = createAsyncThunk<
//   User,
//   { jwt: string; navigate: any }
// >("user/fetchUserProfile", async ({ jwt, navigate }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(`${API_URL}/profile`, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     if (response.data.role === "ROLE_ADMIN") {
//       navigate("/admin");
//     }

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user profile error", error.response);
//     return rejectWithValue("Failed to fetch user profile");
//   }
// });

// export const fetchUserAddresses = createAsyncThunk<
//   Address[],
//   { jwt: string }
// >("user/fetchUserAddresses", async ({ jwt }, { rejectWithValue }) => {
//   try {
//     const response = await api.get(ADDRESS_API_URL, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("fetch user addresses error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to fetch addresses"
//     );
//   }
// });

// export const addUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; address: Address }
// >("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
//   try {
//     const response = await api.post(ADDRESS_API_URL, address, {
//       headers: { Authorization: `Bearer ${jwt}` },
//     });

//     return response.data;
//   } catch (error: any) {
//     console.log("add address error", error.response);
//     return rejectWithValue(
//       error.response?.data?.message || "Failed to add address"
//     );
//   }
// });

// export const updateUserAddress = createAsyncThunk<
//   Address,
//   { jwt: string; addressId: number; address: Address }
// >(
//   "user/updateUserAddress",
//   async ({ jwt, addressId, address }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `${ADDRESS_API_URL}/${addressId}`,
//         address,
//         {
//           headers: { Authorization: `Bearer ${jwt}` },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       console.log("update address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update address"
//       );
//     }
//   }
// );

// export const deleteUserAddress = createAsyncThunk<
//   number,
//   { jwt: string; addressId: number }
// >(
//   "user/deleteUserAddress",
//   async ({ jwt, addressId }, { rejectWithValue }) => {
//     try {
//       await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return addressId;
//     } catch (error: any) {
//       console.log("delete address error", error.response);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to delete address"
//       );
//     }
//   }
// );

// export const updateUserProfile = createAsyncThunk<
//   User,
//   { fullName: string; mobile?: string }
// >(
//   "user/updateUserProfile",
//   async (userData, { rejectWithValue }) => {
//     try {
//       const response = await api.patch(`${API_URL}/profile`, userData, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("jwt")}`,
//         },
//       });

//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to update profile"
//       );
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     resetUserState: (state) => {
//       state.user = null;
//       state.addresses = [];
//       state.loading = false;
//       state.error = null;
//       state.profileUpdated = false;
//       state.addressUpdated = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
    

//       // Fetch Profile
//       .addCase(fetchUserProfile.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })

//       .addCase(
//         fetchUserProfile.fulfilled,
//         (state, action: PayloadAction<User>) => {
//           state.user = action.payload;
//           state.loading = false;
//         }
//       )

//       .addCase(fetchUserProfile.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       // Fetch Addresses
//       .addCase(fetchUserAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })

//       .addCase(
//         fetchUserAddresses.fulfilled,
//         (state, action: PayloadAction<Address[]>) => {
//           state.addresses = action.payload;

//           if (state.user) {
//             state.user.addresses = action.payload;
//           }

//           state.loading = false;
//         }
//       )

//       .addCase(fetchUserAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       // Add Address
//       .addCase(addUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })

//       .addCase(
//         addUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           state.addresses = [...state.addresses, action.payload];

//           if (state.user) {
//             state.user.addresses = [
//               ...(state.user.addresses || []),
//               action.payload,
//             ];
//           }

//           state.loading = false;
//           state.addressUpdated = true;
//         }
//       )

//       .addCase(addUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       // Update Address
//       .addCase(updateUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })

//       .addCase(
//         updateUserAddress.fulfilled,
//         (state, action: PayloadAction<Address>) => {
//           state.addresses = state.addresses.map((address) =>
//             address.id === action.payload.id ? action.payload : address
//           );

//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.map((address) =>
//               address.id === action.payload.id ? action.payload : address
//             );
//           }

//           state.loading = false;
//           state.addressUpdated = true;
//         }
//       )

//       .addCase(updateUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })

//       // Delete Address
//       .addCase(deleteUserAddress.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.addressUpdated = false;
//       })

//       .addCase(
//         deleteUserAddress.fulfilled,
//         (state, action: PayloadAction<number>) => {
//           state.addresses = state.addresses.filter(
//             (address) => address.id !== action.payload
//           );

//           if (state.user?.addresses) {
//             state.user.addresses = state.user.addresses.filter(
//               (address) => address.id !== action.payload
//             );
//           }

//           state.loading = false;
//           state.addressUpdated = true;
//         }
//       )

//       .addCase(deleteUserAddress.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       });
//   },
// });

// export const { resetUserState } = userSlice.actions;

// export default userSlice.reducer;

// export const selectUser = (state: RootState) => state.user.user;
// export const selectUserLoading = (state: RootState) => state.user.loading;
// export const selectUserError = (state: RootState) => state.user.error;



import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { User, UserState, Address } from "../../types/userTypes";
import { api } from "../../Config/Api";
import { RootState } from "../Store";

const initialState: UserState = {
  user: null,
  addresses: [],
  loading: false,
  error: null,
  profileUpdated: false,
  addressUpdated: false,
};

const API_URL = "/api/users";
const ADDRESS_API_URL = "/api/users/addresses";

export const fetchUserProfile = createAsyncThunk<
  User,
  { jwt: string; navigate: any }
>("user/fetchUserProfile", async ({ jwt, navigate }, { rejectWithValue }) => {
  try {
    const response = await api.get(`${API_URL}/profile`, {
      headers: { Authorization: `Bearer ${jwt}` },
    });

    if (response.data.role === "ROLE_ADMIN") {
      navigate("/admin");
    }

    return response.data;
  } catch (error: any) {
    console.log("fetch user profile error", error.response);
    return rejectWithValue("Failed to fetch user profile");
  }
});

export const updateUserProfile = createAsyncThunk<
  User,
  { jwt: string; userData: { fullName: string; mobile?: string; dateOfBirth?: string } }
>(
  "user/updateUserProfile",
  async ({ jwt, userData }, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${API_URL}/profile`, userData, {
        headers: { Authorization: `Bearer ${jwt}` },
      });

      return response.data;
    } catch (error: any) {
      console.log("update profile error", error.response);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update profile"
      );
    }
  }
);

export const fetchUserAddresses = createAsyncThunk<Address[], { jwt: string }>(
  "user/fetchUserAddresses",
  async ({ jwt }, { rejectWithValue }) => {
    try {
      const response = await api.get(ADDRESS_API_URL, {
        headers: { Authorization: `Bearer ${jwt}` },
      });

      return response.data;
    } catch (error: any) {
      console.log("fetch user addresses error", error.response);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch addresses"
      );
    }
  }
);

export const addUserAddress = createAsyncThunk<
  Address,
  { jwt: string; address: Address }
>("user/addUserAddress", async ({ jwt, address }, { rejectWithValue }) => {
  try {
    const response = await api.post(ADDRESS_API_URL, address, {
      headers: { Authorization: `Bearer ${jwt}` },
    });

    return response.data;
  } catch (error: any) {
    console.log("add address error", error.response);
    return rejectWithValue(
      error.response?.data?.message || "Failed to add address"
    );
  }
});

export const updateUserAddress = createAsyncThunk<
  Address,
  { jwt: string; addressId: number; address: Address }
>(
  "user/updateUserAddress",
  async ({ jwt, addressId, address }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `${ADDRESS_API_URL}/${addressId}`,
        address,
        {
          headers: { Authorization: `Bearer ${jwt}` },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log("update address error", error.response);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update address"
      );
    }
  }
);

export const deleteUserAddress = createAsyncThunk<
  number,
  { jwt: string; addressId: number }
>(
  "user/deleteUserAddress",
  async ({ jwt, addressId }, { rejectWithValue }) => {
    try {
      await api.delete(`${ADDRESS_API_URL}/${addressId}`, {
        headers: { Authorization: `Bearer ${jwt}` },
      });

      return addressId;
    } catch (error: any) {
      console.log("delete address error", error.response);
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete address"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserState: (state) => {
      state.user = null;
      state.addresses = [];
      state.loading = false;
      state.error = null;
      state.profileUpdated = false;
      state.addressUpdated = false;
    },

    resetProfileUpdated: (state) => {
      state.profileUpdated = false;
    },

    resetAddressUpdated: (state) => {
      state.addressUpdated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Profile
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchUserProfile.fulfilled,
        (state, action: PayloadAction<User>) => {
          state.user = action.payload;
          state.loading = false;
        }
      )
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Profile
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.profileUpdated = false;
      })
      .addCase(
        updateUserProfile.fulfilled,
        (state, action: PayloadAction<User>) => {
          state.user = action.payload;
          state.loading = false;
          state.profileUpdated = true;
        }
      )
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.profileUpdated = false;
      })

      // Fetch Addresses
      .addCase(fetchUserAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchUserAddresses.fulfilled,
        (state, action: PayloadAction<Address[]>) => {
          state.addresses = action.payload;

          if (state.user) {
            state.user.addresses = action.payload;
          }

          state.loading = false;
        }
      )
      .addCase(fetchUserAddresses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Add Address
      .addCase(addUserAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.addressUpdated = false;
      })
      .addCase(
        addUserAddress.fulfilled,
        (state, action: PayloadAction<Address>) => {
          state.addresses = [...state.addresses, action.payload];

          if (state.user) {
            state.user.addresses = [
              ...(state.user.addresses || []),
              action.payload,
            ];
          }

          state.loading = false;
          state.addressUpdated = true;
        }
      )
      .addCase(addUserAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Address
      .addCase(updateUserAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.addressUpdated = false;
      })
      .addCase(
        updateUserAddress.fulfilled,
        (state, action: PayloadAction<Address>) => {
          state.addresses = state.addresses.map((address) =>
            address.id === action.payload.id ? action.payload : address
          );

          if (state.user?.addresses) {
            state.user.addresses = state.user.addresses.map((address) =>
              address.id === action.payload.id ? action.payload : address
            );
          }

          state.loading = false;
          state.addressUpdated = true;
        }
      )
      .addCase(updateUserAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Address
      .addCase(deleteUserAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.addressUpdated = false;
      })
      .addCase(
        deleteUserAddress.fulfilled,
        (state, action: PayloadAction<number>) => {
          state.addresses = state.addresses.filter(
            (address) => address.id !== action.payload
          );

          if (state.user?.addresses) {
            state.user.addresses = state.user.addresses.filter(
              (address) => address.id !== action.payload
            );
          }

          state.loading = false;
          state.addressUpdated = true;
        }
      )
      .addCase(deleteUserAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetUserState, resetProfileUpdated, resetAddressUpdated } =
  userSlice.actions;

export default userSlice.reducer;

export const selectUser = (state: RootState) => state.user.user;
export const selectUserLoading = (state: RootState) => state.user.loading;
export const selectUserError = (state: RootState) => state.user.error;